module.exports = __webpack_public_path__ + "images/newerp_webicon.1789440611829.png";